import Vue from "vue";
import Vuex from "vuex";

import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";
import authModule from "./auth/moduleAuth";
import profileModule from "./profile/moduleProfile";

Vue.use(Vuex);

const store = new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    auth: authModule,
    profile: profileModule,
  },
  strict: process.env.NODE_ENV !== "production",
});

export default store;
